<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import wx from 'weixin-js-sdk'

	// import {
	// 	initWxConfig
	// } from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";

	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	
	import {
			formatDate
		} from '@/utils/date'
	var logInfo = null;

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea
		},
		data() {
			return {
				"templateData": templateData,
				isDisabled: false,
			}
		},
		mounted() { //页面挂载
			// initWxConfig(this);
			this.getTemplate();
		},
		created() {
		},
		methods: { //方法
			
			getTemplate() {
				let that = this;
				console.log(this.$configure.logInfo);

				// console.log(stringUtils.GetQueryString("templateId"))
				var templateId = stringUtils.GetQueryString("templateId");
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + templateId,
					method: "get",
				}).then(res => {
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}
					console.log(logInfo);
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							that.templateData.TemplateContent.Controls[i].Value = -1;
							var ii = i;
							var processIndex = -1;
							that.$http({
								url: that.$httpUrl.GetRelation + "/" + logInfo.EmpNo + "/employee-relation",
								method: "get",
							}).then(res => {
								var nodes = res.data.Body[0].Nodes;
								var k = 0;
								var items = [];
								var p = 0;
								var isOk = false;
								if (logInfo.fullName.indexOf("住宅部") > -1) {
									if (logInfo.JobLevel < 4 || logInfo.JobLevel > 7||logInfo.fullName.indexOf("住宅部支援中心") > -1) {
										that.templateData.TemplateContent.Controls[ii].Value = processIndex;
									} else {
										processIndex = 1+".";
										var isLevelTen = false;
										for (k = 0; k < nodes.length; k++) {
											if (nodes[k].Items != null) {
												items = nodes[k].Items;
												for (p = 0; p < items.length; p++) {
													if (items[p].JobLevel >= 6 && items[p].JobLevel <= 8) {
														processIndex = 1+"."  + (k + 1);
														isLevelTen = true;
													}
													if (items[p].JobLevel == 8) {
														isOk = true;
													}
												}
											}
										}
										if(!isLevelTen){
											processIndex = 1+"." + 0;
										}
										if (isOk) {
											processIndex = processIndex  + 1;
										} else {
											processIndex = processIndex  + 2;
										}
										that.templateData.TemplateContent.Controls[ii].Value = processIndex;
									}
								} else if (logInfo.fullName.indexOf("房友圈") > -1) {
									
									processIndex = 2;
									that.templateData.TemplateContent.Controls[ii].Value = processIndex;
									if ( logInfo.JobLevel > 4) {
										that.templateData.TemplateContent.Controls[ii].Value = -1;
									}
								} else if (logInfo.fullName.indexOf("二级市场") > -1 || logInfo.fullName.indexOf("代理") > -1) {
									processIndex = 3;
									if ( logInfo.JobLevel > 6) {
										that.templateData.TemplateContent.Controls[ii].Value = processIndex;
									}
									if (logInfo.fullName.indexOf("非营业部") > -1) {
										processIndex = processIndex + "." + 2;
									} else {
										processIndex = processIndex + "." + 1;
										for (k = 0; k < nodes.length; k++) {
											if (nodes[k].Items != null && !isOk) {
												items = nodes[k].Items;
												for (p = 0; p < items.length; p++) {
													if (items[p].JobLevel == 7) {
														processIndex = processIndex + (k + 1);
														isOk = true;
														break;
													}
												}
											}
										}
									}
									that.templateData.TemplateContent.Controls[ii].Value = processIndex;
								} else if (logInfo.fullName.indexOf("工商铺") > -1) {
									processIndex = 4;
									if (logInfo.fullName.indexOf("非营业部") > -1) {
										processIndex = processIndex + "." + 2;
									} else {
										processIndex = processIndex + "." + 1;
										if (logInfo.JobLevel < 4) {
											processIndex = -1;
										}else{
											for (k = 0; k < nodes.length; k++) {
												if (nodes[k].items != null && !isOk) {
													items = nodes[k].items;
													for (p = 0; p < items.length; p++) {
														if (items[p].jobLevel == 7) {
															processIndex = processIndex + (k + 1);
															isOk = true;
															break;
														}
													}
												}
											}
										}
									}
									that.templateData.TemplateContent.Controls[ii].Value = processIndex;
								}
								if (processIndex == -1) {
									this.Message({
										message: '没有申请权限',
										type: 'error',
										duration: 1000
									});
									this.isDisabled = true;
								}
							});

							console.log(processIndex);
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "端口费用承担部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.fullName;
						}
					}
				}, err => {
					console.log(err)
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val) {
				console.log(val);
			},
			submit() {
				let that = this;
//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control1.Value ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "需求时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"需求时间："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "端口类型"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				for (var i = 0; i < control3.Config.Selector.Options.length; i++) {
					var data = control3.Config.Selector.Options[i];
					if(data.Key ==control3.Value){
						NameOfData = data.Value[0].Text;
					}
				}
				info.SummaryInfo.push({"Text":"端口类型："+NameOfData,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				isSubmit = true;
				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					console.log(res);
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {
						that.$message.error(res.data.ErrMsg);
					}
				}, err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
